/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * IS_NULL operator looks for values in the given key that are null.
 */
export interface KeyIsNullAnnotationKey {
    /** The key to compare against. */
    key: string;
}
